module.exports = __webpack_public_path__ + "static/img/keymer.c76332d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/keymer.jpg
// module id = 482
// module chunks = 11